"use client"
import styles from "../../../../styles/finder/finder.module.scss"
import TextInputField from "../../TextInputField/TextInputField"
import { ChangeEvent, useEffect, useState } from "react"
import { useUserStore } from "../store/finder_store"
import StyledText from "../../../typography/typography-component"
import ContactForm from "../ContactForm"
import skColors from "../../../../styles/skColors"
import { useTranslations } from "next-intl"


const Step2a = ({ onDisabledChange }: { onDisabledChange: (value: boolean) => void }) => {
  const t = useTranslations("index.finder")
  const { phone, plz, setPLZ, firstName, lastName, mail } = useUserStore()
  const storeValue = useUserStore.getState()
  const verifyMail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return re.test(email)
  }
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    if (/^\d*$/.test(newValue)) {
      setPLZ(newValue)
    }
  }
  const [errors, setErrors] = useState<{ [key: string]: string }>({})

  useEffect(() => {
    const newErrors: { [key: string]: string } = {}
    if (!firstName) newErrors.firstName = "Vorname ist erforderlich"
    if (!lastName) newErrors.lastName = "Nachname ist erforderlich"
    if (!mail) {
      newErrors.mail = "E-Mail ist erforderlich"
    } else if (!verifyMail(mail)) newErrors.mail = "Ungültige E-Mail-Adresse"
    if (plz.length !== 5) newErrors.plz = "PLZ muss 5-stellig sein"
    if (phone.length < 1) newErrors.phone = "Telefonnummer ist erforderlich"
    if (!storeValue.confirmDataUsage) newErrors.confirmDataUsage = "Bitte Zustimmung erteilen"
    setErrors(newErrors)
    onDisabledChange(Object.keys(newErrors).length > 0)
  }, [onDisabledChange, phone, plz, firstName, lastName, mail, storeValue.confirmDataUsage])


  return (
    <div className={styles.step2Content}>
      <StyledText style={{ paddingBottom: "16px" }} color={skColors.turquoise[600]} variant={"h3"}>
        {t("step1.title")}
      </StyledText>
      <div className={styles.successSection}>
        <StyledText variant="h6" style={{ fontSize: "16px" }} color={skColors.darkgreen[600]}>
          {t("step2a.successText")}
        </StyledText>
        <StyledText  variant="pRegular">
          {t.rich("step2a.successText2", {
            b1: (chunks) => (
              <StyledText as="span" variant="pRegular" style={{ fontWeight: 500 }} color={skColors.darkgreen[600]}>
                {chunks}
              </StyledText>
            ),
            b2: (chunks) => (
              <StyledText as="span" variant="pRegular" style={{ fontWeight: 500 }} color={skColors.darkgreen[600]}>
                {chunks}
              </StyledText>
            ),
          })}
        </StyledText>
      </div>
      <div className={styles.sectionHeading}>
      </div>
      <ContactForm></ContactForm>
    </div>
  )
}

export default Step2a
